import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import { UitkLink } from "uitk-react-link";
import { RouteStore, DialogRoute } from "bernie-core";
import { Layer } from "bernie-view";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { UitkTypeaheadDialog, TypeaheadToolbarVersion, TypeaheadAdapter, ESSAdapter } from "uitk-react-typeahead";
import { withStores } from "src/stores";
import { DestinationSuggestionsStore } from "src/stores/DestinationSuggestionsStore";
import { TypeaheadDialogData } from "../typings";
import { useLocalization } from "@shared-ui/localization-context";

export interface OriginSelectorProps {
  origin: string;
  disableOriginSelector: boolean;
  routeStore: RouteStore;
  context: ExtendedContextStore;
  destinationSuggestions: DestinationSuggestionsStore;
}

export const OriginSelector = withStores(
  "routeStore",
  "context",
  "destinationSuggestions"
)((props: OriginSelectorProps) => {
  const { origin, disableOriginSelector, destinationSuggestions, routeStore, context } = props;
  const dialogId = "origin-selector-dialog";
  const { useRef } = React;
  const dialogRef = useRef<HTMLAnchorElement>(null);
  const essAdapter: TypeaheadAdapter = new ESSAdapter({
    client: "HotelsLandingPage",
    dest: false,
    features: "ta_hierarchy|postal_code",
    guid: context.guid,
    inputId: "origin-selector",
    lob: "HOTELS",
    locale: context.locale,
    maxResults: 7,
    regionType: 4,
    siteId: context.site.id,
  });
  const { formatText } = useLocalization();
  const taLabelToken = "wizard.package.origin.label";

  const handleOriginSelection = (term: string, data: TypeaheadDialogData) => {
    destinationSuggestions.setOriginForDestinationSuggestions(data.regionId);
  };

  const closeOriginDialog = () => {
    routeStore.closeDialog();
    dialogRef?.current?.focus();
  };

  return disableOriginSelector ? (
    <span>{origin}</span>
  ) : (
    <>
      <UitkLink inline={true}>
        <RouterLink
          to={{
            pathname: routeStore.pathname,
            search: routeStore.mergeQueryString(routeStore.search, {
              pwaDialog: dialogId,
            }),
          }}
          innerRef={dialogRef}
        >
          {origin}
        </RouterLink>
      </UitkLink>

      <DialogRoute id={dialogId}>
        <Layer id="dialog" onDismiss={closeOriginDialog}>
          <UitkTypeaheadDialog
            adapter={essAdapter}
            allowExactMatch={true}
            dialog={true}
            label={formatText(taLabelToken)}
            onDismiss={closeOriginDialog}
            onResultItemSelect={handleOriginSelection}
            term={origin}
            toolbarVersion={TypeaheadToolbarVersion.V1}
          />
        </Layer>
      </DialogRoute>
    </>
  );
});
